/**
 * 表单操作
 */
export var FormAction;
(function (FormAction) {
    /**
     * 加签
     */
    FormAction["AdjustParticipant"] = "adjustParticipant";
    /**
     * 同意
     */
    FormAction["Agree"] = "agree";
    /**
     * 协办
     */
    FormAction["Assist"] = "assist";
    /**
     * 作废
     */
    FormAction["Cancel"] = "cancel";
    /**
     * 传阅
     */
    FormAction["Circulate"] = "circulate";
    /**
     * 删除
     */
    FormAction["Delete"] = "delete";
    /**
     * 不同意
     */
    FormAction["DisAgree"] = "disAgree";
    /**
     * 编辑
     */
    FormAction["Edit"] = "edit";
    /**
     * 结束
     */
    FormAction["FinishInstance"] = "finishInstance";
    /**
     * 转办
     */
    FormAction["Forward"] = "forward";
    /**
     * 打印
     */
    FormAction["Print"] = "print";
    /**
     * 驳回
     */
    FormAction["Reject"] = "showReject";
    /**
     * 是否显示审批意见输入框
     */
    FormAction["showCheck"] = "showCheck";
    /**
     * 撤回
     */
    FormAction["Retrieve"] = "retrieve";
    /**
     * 暂存
     */
    FormAction["Save"] = "save";
    /**
     * 提交
     */
    FormAction["Submit"] = "submit";
    /**
     * 催办
     */
    FormAction["Urge"] = "urge";
    /**
     * 评论
     */
    FormAction["Comment"] = "comment";
    /**
     * 修改拥有者
     */
    FormAction["EditOwner"] = "editOwner";
    /**
     * 选择下个节点审批人
     */
    FormAction["ChangeNextNodeUser"] = "changeNextNodeUser";
    /**
     * 表单留痕
     */
    FormAction["FormTrack"] = "formTrack";
    /**
     * 提交并继续创建
     */
    FormAction["addAndCreate"] = "addAndCreate";
})(FormAction || (FormAction = {}));
